module.exports = __webpack_public_path__ + "img/save.7423dee3.svg";